<template>
  <Layout>
    <div slot="body" class="not-found-container">
      <EmptyContent :emptyContentText="$t('errors.not_found')" />
      <div class="link-back-main">
        <router-link :to="{ name: 'cat-main' }">
          {{ $t('common.go_back_to_main') }}
        </router-link>
      </div>
    </div>
  </Layout>
</template>

<script>
  export default {
    name: 'not-found',
  };
</script>

<style lang="scss" scoped>

 .not-found-container {
    max-width: 946px;
    margin: 14px auto;

    .link-back-main {
      text-align: center;

      a {
        cursor: pointer;
        color: #00c896;
      }
    }
 }

</style>




// WEBPACK FOOTER //
// NotFound.vue?2430120c